import styled from 'styled-components';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
export var TableButton = styled(ButtonLined).withConfig({
  displayName: "partials__TableButton",
  componentId: "sc-q1hjy5-0"
})(["background-color:#fff;white-space:nowrap;"]);